/**
 * Server endpoints. In dev, Vite proxies `/api` to localhost:2567 and the
 * Colyseus websocket connects to localhost:2567 directly. In production set
 * `VITE_SERVER_URL` (https URL of the Fly.io app) at build time.
 */
const configured = import.meta.env.VITE_SERVER_URL?.replace(/\/$/, '');

export const HTTP_BASE = configured ?? '';
export const WS_URL =
  configured?.replace(/^http/, 'ws') ??
  `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.hostname}:2567`;

/**
 * Dev latency switch. Adds `LAG_MS` of artificial one-way delay to BOTH outgoing
 * inputs and incoming state, i.e. a simulated round-trip of `2 * LAG_MS`.
 * Set with `?lag=150` in the URL (wins) or `VITE_LAG_MS=150` at build time.
 * Used to verify prediction/interpolation stay snap-free under 150 ms.
 */
function readLag(): number {
  const q = Number(new URLSearchParams(location.search).get('lag'));
  if (Number.isFinite(q) && q >= 0) return q;
  const env = Number(import.meta.env.VITE_LAG_MS);
  return Number.isFinite(env) && env >= 0 ? env : 0;
}

export const LAG_MS = readLag();
